// Show remaining days to the latest appointment date (if in the future)
export function LatestAppointmentDaysLeft({ hearings, t }: any) {
  if (!hearings || hearings.length === 0) return null;
  // Only show if there is NO hearing with if_final_decision_given: true
  if (hearings.some((h: any) => h?.if_final_decision_given === true))
    return null;
  let maxAppt = null;
  for (const h of hearings) {
    if (h?.appointment_date) {
      const d = new Date(h.appointment_date);
      if (!isNaN(d.getTime()) && (!maxAppt || d > maxAppt)) {
        maxAppt = d;
      }
    }
  }
  if (!maxAppt) return null;
  const now = Date.now();
  const diff = maxAppt.getTime() - now;
  if (diff <= 0) return null;
  const daysLeft = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return (
    <span className="ml-2 px-3 py-1 rounded-full bg-red-100 text-red-700 text-xs font-semibold border border-red-200">
      {t("days_left")}: {daysLeft}
    </span>
  );
}
